import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CountryConfigContext } from './country-config-context';
import { getCountryUIConfig } from './country-ui-config';
import * as Actions from '../../store/country/country.actions';
import * as CountryApi from '../../store/country/country.api';
import Global from '../../store/global-selectors';
import { selectCountryConfig } from '../../store/country/country.selectors';

import type { CountryConfig } from './types';
import type { ReactNode } from 'react';

export type CountryConfigProviderProps = {
  children: ReactNode;
};

export const CountryConfigProvider = React.memo(({ children }: CountryConfigProviderProps) => {
  const [countryConfig, setCountryConfig] = useState<CountryConfig>([]);
  const countryCode = useSelector(Global.selectSellerHomeCountry);
  const countryConfigState = useSelector(selectCountryConfig);
  const countryUIConfig = getCountryUIConfig(countryCode);
  const dispatch = useDispatch();

  useEffect(() => {
    const getCountryConfig = async () => {
      if (countryConfigState) {
        setCountryConfig(countryConfigState);
      } else {
        try {
          const sharedConfig = await CountryApi.getCountryFeatures(countryCode);
          const config = [...countryUIConfig, ...sharedConfig];
          setCountryConfig(config);

          dispatch(Actions.setCountryConfig(config));
        } catch {
          setCountryConfig(countryUIConfig);
        }
      }
    };

    getCountryConfig();
  }, [countryCode, countryConfigState, countryUIConfig, dispatch]);

  return <CountryConfigContext.Provider value={{ config: countryConfig }}>{children}</CountryConfigContext.Provider>;
});
